import removeActiveRetentionPolicyTagsOperation from 'owa-service/lib/operation/removeActiveRetentionPolicyTagsOperation';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import IdentityCollectionRequest from 'owa-service/lib/contract/IdentityCollectionRequest';
import configureIdentityCollection from './helpers/configureIdentityCollection';

/**
 * Service to remove policies from the active list
 * @param rawIdentities - raw identities of the retention policy tags
 */
export default function removeActivePolicyTags(
    rawIdentities: string[]
): Promise<OptionsResponseBase> {
    const identityCollection = configureIdentityCollection(rawIdentities);
    return removeActiveRetentionPolicyTagsOperation({
        IdentityCollection: identityCollection,
        Header: getJsonRequestHeader(),
    } as IdentityCollectionRequest);
}
